import { render, staticRenderFns } from "./NavigatorWidget.vue?vue&type=template&id=38a1fc24"
import script from "./NavigatorWidget.vue?vue&type=script&lang=js"
export * from "./NavigatorWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports